import { render, staticRenderFns } from "./ShippingAddressList.vue?vue&type=template&id=a0a60b38&scoped=true&"
import script from "./ShippingAddressList.vue?vue&type=script&lang=js&"
export * from "./ShippingAddressList.vue?vue&type=script&lang=js&"
import style0 from "./ShippingAddressList.vue?vue&type=style&index=0&id=a0a60b38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0a60b38",
  null
  
)

export default component.exports